/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgConfigureBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 8L11 13M11.6675 13.9386L10.0617 12.3329C9.9562 12.2273 9.83097 12.1436 9.69314 12.0865C9.55531 12.0294 9.40757 12 9.25837 12C9.10917 12 8.96144 12.0294 8.8236 12.0865C8.68577 12.1436 8.56054 12.2273 8.45508 12.3329L3.63759 17.1509C3.22385 17.5793 2.99491 18.153 3.00009 18.7485C3.00526 19.344 3.24413 19.9137 3.66526 20.3348C4.08638 20.7559 4.65606 20.9947 5.25159 20.9999C5.84713 21.0051 6.42087 20.7762 6.84925 20.3624L11.6675 15.5444C11.8804 15.3314 12 15.0426 12 14.7415C12 14.4404 11.8804 14.1516 11.6675 13.9386ZM17.5947 3.56807C17.6993 3.41104 17.8375 3.27919 17.9993 3.18203C18.1611 3.08487 18.3424 3.02483 18.5302 3.00622C18.718 2.98761 18.9075 3.0109 19.0852 3.07442C19.2629 3.13794 19.4243 3.2401 19.5578 3.37354L20.6265 4.44225C20.7599 4.57568 20.8621 4.73707 20.9256 4.91476C20.9891 5.09246 21.0124 5.28203 20.9938 5.46982C20.9752 5.6576 20.9151 5.83892 20.818 6.00069C20.7208 6.16246 20.589 6.30066 20.4319 6.40531L18.4366 7.73635C18.1352 7.93753 17.7734 8.02802 17.4128 7.99242C17.0522 7.95682 16.7151 7.79733 16.4589 7.54111C16.2027 7.28489 16.0432 6.94778 16.0076 6.58718C15.972 6.22659 16.0625 5.8648 16.2636 5.56342L17.5947 3.56807Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgConfigure = wrapIcon(SvgConfigureBase);
export default SvgConfigure;
